// Hand a Blob to the browser as a file download (anchor + click + revoke).
// Generic on purpose so any file-bearing feature can reuse it; pair with
// base64ToBlob (lib/use-open-document) when the payload is a GraphQL `Binary`.
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
